import cn from 'classnames';
import isNull from 'lodash.isnull';
import { Link, Navigate, useLocation, useParams } from 'react-router-dom';
import { useUserStore } from '../../../components/userStore';
import ClientForm from './ClientForm';
import ExistingClient from './ExistingClient';
import MemberFileSearch from './MemberFileSearch';
import { useApplicationStore } from './applicationStore';

const ChooseClient = () => {
	const { user } = useUserStore();
	const { type } = useParams();
	const location = useLocation();
	const { program, resetClient, getClient } = useApplicationStore();

	const isNew = type === 'new';
	const isExisting = type === 'existing';
	const isEligibilityUser = type === 'eligibility';
	const isHealthplanAgency = ['healthplan', 'clinical'].includes(
		user?.coord_agency?.agency_type,
	);

	// check whether the previous route was the organizations page
	const cameFromOrganizations =
		location?.state?.from?.pathname?.includes('organizations');
	if (cameFromOrganizations && isNull(program)) {
		return <Navigate to="/newApplication/organizations" replace />;
	}

	return (
		<div>
			{!isNew && !isExisting && !isEligibilityUser && (
				<>
					<h1>New or Existing Profile?</h1>
					<div
						className={cn(
							'grid',
							{
								'grid-cols-7': !isHealthplanAgency,
								'grid-cols-10': isHealthplanAgency,
							},
							'gap-4',
							'my-8',
						)}
					>
						<div className="col-span-2 col-start-2">
							<Link
								className="btn btn-primary btn-block"
								to="new"
								onClick={resetClient}
							>
								New Profile
							</Link>
						</div>
						<div className="col-span-2 col-start-5">
							<Link className="btn btn-primary btn-block" to="existing">
								Existing Profile
							</Link>
						</div>
						{isHealthplanAgency && (
							<div className="col-span-2 col-start-8">
								<Link className="btn btn-primary btn-block" to="eligibility">
									Search Eligibility List
								</Link>
							</div>
						)}
					</div>
				</>
			)}
			{!isNew && isExisting && !isEligibilityUser && <ExistingClient />}
			{isNew && !isExisting && !isEligibilityUser && (
				<>
					<h1>
						{getClient().id ? `Edit Profile` : `New Profile`} Contact
						Information
					</h1>
					<p>
						<span className="text-error">*</span> Indicates required field
					</p>
					<div className="new-client">
						<ClientForm />
					</div>
				</>
			)}
			{!isNew && !isExisting && isEligibilityUser && <MemberFileSearch />}
			<div className="grid grid-cols-2 mt-8">
				<div className="col-start-1"></div>
				{isNew && (
					<div className="flex justify-end">
						<Link
							className="btn btn-primary btn-wide"
							to="/newApplication/secure"
						>
							Next
						</Link>
					</div>
				)}
			</div>
		</div>
	);
};

export default ChooseClient;
